import { render, staticRenderFns } from "./VCardContent.vue?vue&type=template&id=47fc1380&"
import script from "./VCardContent.vue?vue&type=script&setup=true&lang=ts&"
export * from "./VCardContent.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./VCardContent.vue?vue&type=style&index=0&id=47fc1380&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports